namespace GeniuzPOS.QRreport {
    export class QMonthColumns {
        static columnsKey = 'QRreport.QMonth';
    }
}
